var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcChevronUpRegular = function SvgIcChevronUpRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.363 7.863a.9.9 0 0 1 1.273 0l7 7a.9.9 0 1 1-1.273 1.273L12 9.772l-6.364 6.364a.9.9 0 1 1-1.273-1.273z",
    clipRule: "evenodd"
  })));
};
export default SvgIcChevronUpRegular;